if (!customElements.get("m-product-details-tabs")) {
  class MProductDetailsTabs extends HTMLElement {
    constructor() {
      super();
      this.tabs = new MinimogTheme.Tabs(this);
      this.handleReviewBadgeClick = this.handleReviewBadgeClick.bind(this);

      if (Shopify.designMode) {
        document.addEventListener("shopify:block:select", (event) => {
          const tabHeader = event && event.target;
          const index = (tabHeader && Number(tabHeader.dataset.index)) || 0;
          this.tabs && this.tabs.setActiveTab(index);
        });
      }
    }

    connectedCallback() {
      document.addEventListener("click", this.handleReviewBadgeClick, true);
    }

    disconnectedCallback() {
      document.removeEventListener("click", this.handleReviewBadgeClick, true);
    }

    handleReviewBadgeClick(event) {
      const badge = event.target.closest?.(".jdgm-prev-badge, .jdgm-preview-badge");
      if (!badge) return;

      const headers = Array.from(this.querySelectorAll(".m-tab-header"));
      const reviewIndex = headers.findIndex((header) => header.dataset.blockType === "reviews");
      if (reviewIndex === -1) return;

      this.tabs?.setActiveTab(reviewIndex);
      window.requestAnimationFrame(() => {
        this.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    }
  }
  customElements.define("m-product-details-tabs", MProductDetailsTabs);
}
